import { LineChart } from "@mantine/charts";
import { InspectorStats } from "@/api/williams/dashboard";

export type InspectionVolumeTrendProps = {
  data: InspectorStats[];
};

export function InspectionVolumeTrend({ data }: InspectionVolumeTrendProps) {
  console.log("InspectionVolumeTrend - Raw data:", data);

  // Aggregate inspection data by month across all inspectors
  const aggregatedData = [
    { month: "Jan", value: data?.reduce((sum, inspector) => sum + (inspector.january || 0), 0) || 0 },
    { month: "Feb", value: data?.reduce((sum, inspector) => sum + (inspector.february || 0), 0) || 0 },
    { month: "Mar", value: data?.reduce((sum, inspector) => sum + (inspector.march || 0), 0) || 0 },
    { month: "Apr", value: data?.reduce((sum, inspector) => sum + (inspector.april || 0), 0) || 0 },
    { month: "May", value: data?.reduce((sum, inspector) => sum + (inspector.may || 0), 0) || 0 },
    { month: "Jun", value: data?.reduce((sum, inspector) => sum + (inspector.june || 0), 0) || 0 },
    { month: "Jul", value: data?.reduce((sum, inspector) => sum + (inspector.july || 0), 0) || 0 },
    { month: "Aug", value: data?.reduce((sum, inspector) => sum + (inspector.august || 0), 0) || 0 },
    { month: "Sep", value: data?.reduce((sum, inspector) => sum + (inspector.september || 0), 0) || 0 },
    { month: "Oct", value: data?.reduce((sum, inspector) => sum + (inspector.october || 0), 0) || 0 },
    { month: "Nov", value: data?.reduce((sum, inspector) => sum + (inspector.november || 0), 0) || 0 },
    { month: "Dec", value: data?.reduce((sum, inspector) => sum + (inspector.december || 0), 0) || 0 },
  ];

  // Map data to have an 'Inspections' property for the series
  const chartData = aggregatedData.map((d) => ({ month: d.month, Inspections: d.value }));

  // Check if there's any real data
  const hasData = aggregatedData.some((d) => d.value > 0);

  return (
    <div style={{ height: "300px" }}>
      {hasData ? (
        <LineChart
          data={chartData}
          dataKey="month"
          series={[{ name: "Inspections", color: "teal" }]}
          withLegend={false}
          h={250}
        />
      ) : (
        <div className="alert alert-info mb-3">
          <small>No inspection data available.</small>
        </div>
      )}
    </div>
  );
}
